import { HttpClient } from '@angular/common/http'
import { ChangeDetectionStrategy, Component, inject, Inject } from '@angular/core'
import { filter, Observable, take } from 'rxjs'
import { RepresentativeDto } from '../../../../shared/models/auth.interfaces'
import { NavigationLink } from '../../../../shared/models/interfaces'
import { DASHBOARD_SIDEBAR_MENU } from '../../../injectors/dashboard.injector'
import { AuthService } from '../../../services/auth.service'
import { DashboardSidebarService } from '../../../services/dashboard-sidebar.service'

@Component({
    selector: 'app-dashboard-layout-sidebar',
    templateUrl: './dashboard-layout-sidebar.component.html',
    styleUrls: ['./dashboard-layout-sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardLayoutSidebarComponent {
    private httpClient = inject(HttpClient)

    version$ = this.httpClient.get('assets/version', { responseType: 'text' })

    constructor(
        private authService: AuthService,
        private dashboardSidebarService: DashboardSidebarService,
        @Inject(DASHBOARD_SIDEBAR_MENU) public readonly navigation: NavigationLink[]
    ) {}

    toggleSidebar(): void {
        this.dashboardSidebarService.toggleSidebar()
    }

    navigationClick(): void {
        this.dashboardSidebarService.isMobile$
            .pipe(
                take(1),
                filter((value: boolean) => value)
            )
            .subscribe(() => this.dashboardSidebarService.hideSidebar())
    }

    get currentRepresentative$(): Observable<RepresentativeDto | null> {
        return this.authService.currentRepresentative
    }

    get isOpenSidebar$(): Observable<boolean> {
        return this.dashboardSidebarService.isOpenSidebar$
    }
}
